<ng-container *ngIf="!isDisabled">
  <div *ngIf="tenants() as tenants">
    <div class="search-bar">
      <wr-search-bar class="grow"
                     [search]="searchText()"
                     (searchChange)="searchTextChange($event)">
      </wr-search-bar>
    </div>
    <div class="list" *ngIf="tenants.length > 0; else noItems">
      <div class="list-item" *ngFor="let tenant of filteredCheckboxTenants()">
        <nb-checkbox [checked]="isChecked(tenant)" (checkedChange)="toggle($event, tenant)">
          <div class="tenant-name" (click)="goToTenant($event, tenant)">
            {{tenant.name}}
          </div>
        </nb-checkbox>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="isDisabled">
  <wr-list-view [items]="filteredAssignedTenants()"
                [searchText]="searchText()"
                (searchTextChange)="searchTextChange($event)">
    <ng-template wrListItem let-item>
      <div>{{ item.name }}</div>
    </ng-template>
  </wr-list-view>
</ng-container>

<ng-template #noItems>
  <span class="text-hint no-items">
    <nb-icon icon="slash-outline" pack="eva"></nb-icon>
    <span>Keine Tenants</span>
  </span>
</ng-template>

